module.exports = __webpack_public_path__ + "static/scale-model-of-berkeley-california-96023f40fcce6912cde96f3e92e3046d.png";